import { isFiniteNumber } from "./is-finite-number";

export const isFinitePositive = (value: any): value is number => isFiniteNumber(value) && value > 0;
